import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from 'api/base';
import { type ResultData, SUGGESTION_FIELD } from 'types/result';

export function useRetrySuggestions(id: number, onError: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      post('retrySuggestions', undefined, [id, 'suggestions']) as Promise<ResultData>,
    onSuccess: (fresh) => {
      const sections = Object.fromEntries(
        Object.values(SUGGESTION_FIELD).map((field) => [field, fresh[field]])
      );
      queryClient.setQueryData<ResultData>(['conversation', fresh.id], (previous) =>
        previous
          ? {
              ...previous,
              ...sections,
              suggestions: fresh.suggestions,
              suggestionsFailed: fresh.suggestionsFailed,
              vitalParameters: fresh.vitalParameters,
            }
          : fresh
      );
      if (fresh.suggestionsFailed) {
        onError();
      }
    },
    onError,
  });
}
